import React, { useMemo } from 'react';

// Subtle falling gold particles rendered as a fixed, non-interactive ambient layer on all pages.
const GoldRain = ({ count = 75 }) => {
  const drops = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const isFleck = i % 4 === 0;
        return {
          id: i,
          left: Math.random() * 100,
          delay: -Math.random() * 12,
          duration: 6 + Math.random() * 8,
          drift: (Math.random() - 0.5) * 40,
          height: isFleck ? 3 + Math.random() * 3 : 26 + Math.random() * 44,
          width: isFleck ? 3 + Math.random() * 3 : 1 + Math.random() * 1.5,
          opacity: 0.12 + Math.random() * 0.25,
          fleck: isFleck,
        };
      }),
    [count]
  );

  return (
    <div className="gold-rain" aria-hidden="true">
      {drops.map((d) => (
        <span
          key={d.id}
          className="gold-drop"
          style={{
            left: `${d.left}%`,
            width: `${d.width}px`,
            height: `${d.height}px`,
            opacity: d.opacity,
            borderRadius: d.fleck ? '50%' : '2px',
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.duration}s`,
            '--drift': `${d.drift}px`,
          }}
        />
      ))}
    </div>
  );
};

export default GoldRain;
